import React, { useState } from 'react'
import * as SearchStyles from './Search.module.scss'
import Search from '../../../assets/search.svg'
import { navigate } from 'gatsby'

const SearchOverlay = ({
  visibility,
  onClose
}: {
  visibility: boolean
  onClose: () => void
}) => {
  const [search, setSearch] = useState<string | null>(null)

  if (!visibility) {
    return null
  }

  const handleSearch = () => {
    if (search) {
      onClose()
      navigate(`/search/?q=${search}`)
    }
  }

  return (
    <div className={SearchStyles.Wrapper}>
      <p>
        <label>Search for the fun stuff</label>
        <form className={SearchStyles.Search} onSubmit={() => handleSearch()}>
          <input
            type={`search`}
            name="Search"
            id="Search"
            onChange={e => setSearch(e.target.value)}
          />
          <img src={Search} alt="Search" onClick={() => handleSearch()} />
        </form>
        <span className={SearchStyles.Close} onClick={() => onClose()}>
          Close
        </span>
      </p>
    </div>
  )
}

export default SearchOverlay
